export default {"src":"/_next/static/media/view-icon.52ba2512.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};